import { render, staticRenderFns } from "./WrapMaterialGlobalFilter.vue?vue&type=template&id=63544cbb&scoped=true&lang=html&"
import script from "./WrapMaterialGlobalFilter.vue?vue&type=script&lang=js&"
export * from "./WrapMaterialGlobalFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63544cbb",
  null
  
)

export default component.exports